import { getCDNImageURL } from "./getCDNImageURL";

// Given a list of Cloudflare Image UUIDs, paired with their entity reference (special_id, comedian_id, etc),
// retrieve the Image URLs. Returns an array of objects where each UUID is mapped to its corresponding URL.
// Fallback to Punchup logo if a UUID is not found.
export const getCDNImageURLArray = async (
  imageEntity: { entityId: string; imageId: string }[]
): Promise<{ entityId: string; imageId: string; imageUrl: string }[]> => {
  return await Promise.all(
    imageEntity.map(async (i) => {
      const { entityId, imageId } = i;
      // Punchup logo as default - even though we can expect these comedians to always have an image
      const fallbackImgUrl =
        "https://imagedelivery.net/7Ze32-hXUdrEDVtqvlbDMQ/dc9b5063-beaf-4709-e04b-eca128e74c00/public";
      let imageUrl;
      if (imageId) {
        try {
          imageUrl = getCDNImageURL(imageId);
        } catch {
          imageUrl = fallbackImgUrl;
          console.error("failed to fetch image from CDN");
        }
      } else {
        imageUrl = fallbackImgUrl;
      }
      return {
        entityId,
        imageId,
        imageUrl,
      };
    })
  );
};
